import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getSiteEnvVarValue} from '../../../utils/site-config'

export const useExactDeliveryDates = (location) => {
    const {site} = useMultiSite()
    const key =
        location === 'checkout'
            ? 'ENABLE_EXACT_DELIVERY_DATES_ON_CHECKOUT'
            : 'ENABLE_EXACT_DELIVERY_DATES_ON_PDP'
    return getSiteEnvVarValue(getConfig()?.app, key, site?.id) === 'true'
}
